import React from 'react';

// The same unbounded count is used online and offline; it is not a progress bar.
export default function CounterReadout({ count, label, language, caption = label }) {
  const formatted = count.toLocaleString(language);
  return <div className={`counter-total${formatted.length > 9 ? ' counter-total--long' : ''}`}>
    <output className="counter-total-value" aria-label={label} aria-live="polite" dir="ltr">{formatted}</output>
    <span className="counter-total-caption">{caption}</span>
  </div>;
}
